/**
 * 申请单信息
 */
import React from 'react';

import { Input, Button, Row, Col, Icon, Tooltip, DatePicker, Select } from 'antd';
import moment from 'moment';

import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';

//信息编辑
import ContractManageEdit from './ContractManageEdit';

//消息提示
import messager from '../../ui/messager';
//加载中遮罩
import Loading from '../../ui/Loading';
import ContractManageDetail from './ContractManageDetail'
import ContractManageFile from './ContractManageFile'
import { global_data } from '../../ui/auth'

const pageCode = [{
    'text': '新增合同',
    'code': 'CONTRACT_MANAGE_ADD',
}, {
    'text': '编辑',
    'code': 'CONTRACT_MANAGE_EDIT',
}, {
    'text': '招商经理通过',
    'code': 'CONTRACT_MANAGE_M_AUDIT',
}, {
    'text': '招商经理退回',
    'code': 'CONTRACT_MANAGE_M_REJECT',
}, {
    'text': '财务经理通过',
    'code': 'CONTRACT_MANAGE_F_AUDITED',
}, {
    'text': '财务经理退回',
    'code': 'CONTRACT_MANAGE_F_REJECT',
}, {
    'text': '审核通过',
    'code': 'CONTRACT_MANAGE_AUDIT',
}, {
    'text': '合同退回',
    'code': 'CONTRACT_MANAGE_REJECT',
}, {
    'text': '合同删除',
    'code': 'CONTRACT_MANAGE_DELETE',
}, {
    'text': '下载',
    'code': 'CONTRACT_MANAGE_DOWNLOAD',
}, {
    'text': '上传附件',
    'code': 'CONTRACT_MANAGE_UPLOAD',
}, {
    'text': '提交审核',
    'code': 'CONTRACT_MANAGE_COMMIT',
}]

class ContractManageIndex extends React.Component {
    columns = [{
        title: '审批号',
        dataIndex: 'auditCode',
        width: '18%',
    },{
        title: '楼层',
        dataIndex: 'floorStr',
        width: '8%',
    }, {
        title: '铺位号',
        dataIndex: 'berthStr',
        width: '15%',
    }, {
        title: '租用面积',
        dataIndex: 'buildingArea',
        width: '9%',
    }, {
        title: '签约公司',
        dataIndex: 'clientName',
        width: '20%',
    }, {
        title: '租赁起始日期',
        dataIndex: 'rentStartDate',
        width: '13%',
    }, {
        title: '租赁结束日期',
        dataIndex: 'rentEndDate',
        width: '13%',
    }, {
        title: '合约期',
        dataIndex: 'leaseMonth',
        width: '8%',
    }, {
        title: '合同状态 ',
        dataIndex: 'statusStr',
        width: '13%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("CONTRACT_MANAGE_DETAIL")?
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("CONTRACT_MANAGE_EDIT")&&(record.status === 'DRAFT'||record.status === 'MERCHANTS_REJECT'||record.status === 'FINANCE_REJECT'||record.status === 'REJECT')?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.id)} />
                </Tooltip> : ''
                }
                {global_data.authCode.includes("CONTRACT_MANAGE_DELETE")?
                <Tooltip title="删除合同">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("CONTRACT_MANAGE_UPLOAD")?
                <Tooltip title="附件">
                    <Icon type="file" className="table-operate-icon" onClick={this.download.bind(this, record)} />
                </Tooltip>
                :""}
                {/* <Tooltip title="生成账单">
                    <Icon type="schedule" theme="filled" className="table-operate-icon" onClick={this.download.bind(this, text)} />
                </Tooltip> */}
            </div>
        ),
    }];

    state = {
        visible: false,
        downloadVisible: false,
        clientName: '',
        id: 0,
        loadData: '',
        editData: {},   //编辑页面使用的数据
        detailData: {},  //详情页面使用的数据
        //个人服务收费
        queryData: {}, //查询数据
        loadingVisible: false,
        detailVisible: false,
        codeList: [],
        floorList: [],
        allFloorList: [],
        buildingList: [],
        fileData: {},
        berthRentList: [],
        finishDate:""
    };
    componentDidMount() {
        let codeList = [];
        for (let i = 0; i < global_data.authCode.length; i++) {
            for (let j = 0; j < pageCode.length; j++) {
                if (global_data.authCode[i] === pageCode[j].code) {
                    codeList.push(global_data.authCode[i])
                }
            }
        }
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                let buildingId = "";
                let queryData = { buildingId: buildingId };
                this.setState({ buildingList: buildingList, queryData: queryData });
                this.state.loadData(queryData);
                http.get({
                    url: "/berth/findFloor",
                    success: (floor) => {
                        floor = floor == null ? [] : floor;
                        let floorList = [];
                        if (buildingId != null) {
                            floor.forEach(item => {
                                // eslint-disable-next-line eqeqeq
                                if (item.buildingId == buildingId) {
                                    floorList.push(item);
                                }
                            });
                        }
                        this.setState({ floorList: floorList, allFloorList: floor });
                    }
                });
            }
        });
        //获取所有的标准租金信息
        http.get({
            url: "/berth/findAllBerthRent",
            success: (res) => {
                this.setState({ berthRentList: res });
            }
        });
        this.setState({
            codeList: codeList
        })
    }
    add = () => {
        let queryData = this.state.queryData;
        let buildingId = queryData.buildingId ? queryData.buildingId : 1;
        this.setState({
            editData: {
                "busiManageContractVO.otherFeeStrategy": 2,
                "buildingId": buildingId,
            }
        });
        this.child.loadClientTree(buildingId);
        this.child.emptyStandardList();
        this.child.initClientTypeDetail();
        this.showModal();
    }

    update = (info, e) => {
        let queryData = this.state.queryData;
        let buildingId = queryData.buildingId ? queryData.buildingId : 1;
        this.setState({ loadingVisible: true });
        http.get({
            url: '/market/contract/query/' + info,
            success: (res) => {
                //租金标准
                let rentStandardList = res.rentStandardList;
                if (rentStandardList) {
                    if (rentStandardList !== null && rentStandardList !== undefined) {
                        for (let index in rentStandardList) {
                            rentStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            rentStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                else {
                    rentStandardList = [];
                }
                //物管费标准
                let busiFeeStandardList = [];
                if (res.busiManageContractVO && res.busiManageContractVO.busiFeeStandardList && res.busiManageContractVO.busiFeeStandardList.length > 0) {
                    busiFeeStandardList = res.busiManageContractVO.busiFeeStandardList;
                    if (busiFeeStandardList !== null && busiFeeStandardList !== undefined) {
                        for (let index in busiFeeStandardList) {
                            busiFeeStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            busiFeeStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                this.showModal();
                this.transferData(res, "partybAccount");
                this.transferData(res, "partybContactInfo");
                this.transferData(res, "busiManageContractVO");
                this.state.initEdit(rentStandardList, busiFeeStandardList, res.berthIds, res.freeMonth);
                this.child.loadClientTree(buildingId);
                this.child.initClientTypeDetail(res.businessCategory);
                this.setState({ loadingVisible: false, editData: res });
            },
            error: (res) => {
                messager.alert("返回信息异常！", "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }
    // 附件
    download = (info) => {
        this.state.initFile(info);
        this.setState({ downloadVisible: true, fileData: info });
    }
    onRef = (ref) => {
        this.child = ref

    }

    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }

    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/market/contract/query/contractAndBills/' + info,
            success: (res) => {
                //租金标准
                let rentStandardList = res.rentStandardList;
                if (rentStandardList) {
                    if (rentStandardList !== null && rentStandardList !== undefined) {
                        for (let index in rentStandardList) {
                            rentStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            rentStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                else {
                    rentStandardList = [];
                }
                //物管费标准
                let busiFeeStandardList = [];
                if (res.busiManageContractVO && res.busiManageContractVO.busiFeeStandardList && res.busiManageContractVO.busiFeeStandardList.length > 0) {
                    busiFeeStandardList = res.busiManageContractVO.busiFeeStandardList;
                    if (busiFeeStandardList !== null && busiFeeStandardList !== undefined) {
                        for (let index in busiFeeStandardList) {
                            busiFeeStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            busiFeeStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                this.transferData(res, "partybAccount");
                this.transferData(res, "partybContactInfo");
                this.transferData(res, "busiManageContractVO");
                this.state.initDetail(rentStandardList, busiFeeStandardList, res.berthIds, res.freeMonth);
                let allMoney = 0;  //总金额
                //let payCount = 0; // 已付账单次数
                let payMoney = 0; //已付金额
                if (res['tenantFeesList'] !== undefined) {
                    for (let i = 0; i < res['tenantFeesList'].length; i++) {
                        allMoney += res['tenantFeesList'][i].totalFees;
                        if (res['tenantFeesList'][i].status === 2) {
                            //payCount++;
                            payMoney += res['tenantFeesList'][i].totalFees
                        }
                    }
                    res.allMoney = allMoney;
                    res.payMoney = payMoney;
                    res.payProportion = ((payMoney / allMoney) * 100).toFixed(2);   // 已付账单完成比例
                }
                this.setState({ detailData: res, detailVisible: true, loadingVisible: false,finishDate:res.contractLogList[0].finishDate});
            },
            error: (res) => {
                messager.alert("返回信息异常！", "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }
    delete = (info, e) => {
        messager.confirm("是否删除该合同？", () => {
            this.setState({ loadingVisible: true });
            http.post({
                url: '/market/contract/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert("返回信息异常！", "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }
    showModal = () => {
        this.setState({ visible: true });
    }
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }
    hiddenDownloadModal = () => {
        this.reloadDataFunc();
        this.setState({ downloadVisible: false });
    }
    reloadDataFunc = () => {
        let queryData = this.state.queryData;
        this.state.loadData(queryData);
    }

    hiddenDetailModal = () => {
        this.setState({ detailVisible: false });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (field, value, e) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        if (field === "buildingId") {
            let floor = this.state.allFloorList;
            let floorList = [];
            floor.forEach(item => {
                // eslint-disable-next-line eqeqeq
                if (item.buildingId == value) {
                    floorList.push(item);
                }
            });
            this.setState({ floorList: floorList });
            queryData["floorId"] = null;
        }
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="签约客户"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginLeft: '10px', width: 300, marginRight: '10px' }} />
                                <Select onChange={this.selectChange.bind(this, "buildingId")} placeholder="所属市场" value={this.state.queryData.buildingId} style={{ width: 200 }}>
                                        <Select.Option value="">全部</Select.Option>
                                        {this.state.buildingList.map(d =>
                                            <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                        )}
                                </Select>
                                <Select onChange={this.selectChange.bind(this, "floorId")} placeholder="商铺楼层" value={this.state.queryData.floorId} allowClear={true} style={{ width: 150, margin: '0 10px' }}>
                                    {this.state.floorList.map(d =>
                                        <Select.Option key={d["id"]}>{d["floorName"]}</Select.Option>
                                    )}
                                </Select>
                                <Select allowClear={true} placeholder="合同状态" onChange={this.selectChange.bind(this, "statusSet")} style={{ width: '150px', margin: '0 10px' }}>
                                    <Select.Option key="DRAFT,REJECT,MERCHANTS_REJECT,FINANCE_REJECT">草稿</Select.Option>
                                    <Select.Option key="COMMIT">招商经理审核</Select.Option>
                                    <Select.Option key="MERCHANTS_AUDITED">财务经理审核</Select.Option>
                                    <Select.Option key="FINANCE_AUDITED">总经理审核</Select.Option>
                                    <Select.Option key="AUDITED,FINISH_REJECT,FINISH_MERCHANTS_REJECT,FINISH_FINANCE_REJECT">履约中</Select.Option>
                                    <Select.Option key="FINISH">履约结束</Select.Option>
                                    <Select.Option key="FINISH_COMMIT">招商经理审核退租</Select.Option>
                                    <Select.Option key="FINISH_MERCHANTS_AUDITED">财务经理审核退租</Select.Option>
                                    <Select.Option key="FINISH_FINANCE_AUDITED">总经理审核退租</Select.Option>
                                </Select>
                                {/* <DictSelect category="MARKET_CONTRACT_STATUS" allowClear={true} placeholder="选择状态" onChange={this.selectChange.bind(this, "status")} style={{ width: '150px', margin: '0 10px' }} /> */}
                            </Col>

                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("CONTRACT_MANAGE_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    requestType="get"
                    rowKey="id"
                    url="/market/contract/query/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ContractManageEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.reloadDataFunc}
                    onRef={this.onRef}
                    initEdit={(func) => { this.setState({ initEdit: func }) }}
                    codeList={this.state.codeList}
                    buildingList={this.state.buildingList}
                    berthRentList={this.state.berthRentList}
                />
                <ContractManageDetail
                    successCallback={this.reloadDataFunc}
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenDetailModal.bind(this)}
                    detailData={this.state.detailData}
                    codeList={this.state.codeList}
                    initDetail={(func) => { this.setState({ initDetail: func }) }}
                />
                <ContractManageFile
                    onCancel={this.hiddenDownloadModal}
                    visible={this.state.downloadVisible}
                    editData={this.state.editData}
                    successCallback={this.reloadDataFunc}
                    fileData={this.state.fileData}
                    initFile={(func) => { this.setState({ initFile: func }) }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
               
            </div>
        )
    }
}

export default ContractManageIndex;